import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable} from 'rxjs';
import { environment } from 'src/environments/environment';
import { PaginationModel } from '../models/pagination-model';


@Injectable({ providedIn: 'root' })
export class NetworkService {
    
    
    
    private readonly apiUrl = environment.apiEndpoint + 'network';

    constructor(private http:HttpClient) {}


    getMyNetwork(pageNum: number, pageSize: number, palabraClave: string, idTarjeta?: number | string | null) : Observable<PaginationModel>{
      let finalurl = this.apiUrl + '?pageNum='+pageNum+'&pageSize='+pageSize+'&palabraClave='+ palabraClave
      if (idTarjeta) finalurl += '&idTarjeta=' + idTarjeta;
        return this.http.get<PaginationModel>(finalurl, { withCredentials: true });
    }
    
    getMyPublicNetwork(pageNum: number, pageSize: number, palabraClave: string, idCliente: string | null) {
      let finalurl = this.apiUrl + '/client/' + idCliente  + '?pageNum='+pageNum+'&pageSize='+pageSize+'&palabraClave='+ palabraClave
        return this.http.get<PaginationModel>(finalurl, { withCredentials: true });
    }


}
